import { JsonProperty } from 'json-object-mapper';
import { annualizedPreviewAmount } from '../utils/preview-renewal-pricing.utils';
import { PreviewPricingItem } from './preview-pricing-item.model';

/**
 * One renewal price preview for a single contract duration. The subscription
 * preview HTTP API returns `PreviewForRenewalResponse[]` (e.g. 12 / 36 / 60 months).
 */
export class PreviewForRenewalResponse {
  @JsonProperty() public floorPriceApplied?: boolean;
  @JsonProperty() public frequency?: string;
  @JsonProperty() public items: PreviewPricingItem[];
  @JsonProperty() public onlyPlatinum: boolean;
  @JsonProperty() public planCode: string;
  @JsonProperty() public successPlanPremium: number;
  @JsonProperty() public totalAmount: number;
  @JsonProperty() public totalListPrice: number;
  /** Contract length in months for this preview row (e.g. 12, 36, 60). */
  @JsonProperty() public duration?: number;

  constructor() {
    this.floorPriceApplied = false;
    this.frequency = null;
    this.items = [];
    this.onlyPlatinum = null;
    this.planCode = null;
    this.successPlanPremium = null;
    this.totalAmount = 0;
    this.totalListPrice = 0;
  }

  get annualRenewalPrice(): number {
    return annualizedPreviewAmount({
      totalAmount: this.totalAmount,
      duration: this.duration,
    });
  }

  get discountAmount(): number {
    return this.totalListPrice > this.totalAmount
      ? this.totalListPrice - this.totalAmount
      : 0;
  }

  get getDiscountPercentage(): number {
    if (this.totalListPrice <= 0 && this.totalListPrice < this.totalAmount) {
      return 0;
    }

    const discount = (this.discountAmount / this.totalListPrice) * 100;
    return Math.round(discount);
  }

  get isDiscountPresent(): boolean {
    return this.totalListPrice >= 0 && this.totalAmount < this.totalListPrice;
  }
}
